<template>
  <div class="row">
    <div class="col-lg-10 offset-lg-1">
      <!--Contact Form-->
      <form id="suggestions-form" class="form" method='POST' @submit.prevent="submitForm">
        <div class="row">
          <div class="col-md-6 form-group">
            <input type="text" class="form-control con-validate" v-model="suggestion.name" :placeholder="$t('sugerencias.campos.nombre') + '*'" minlength=3
                   required>
          </div>
          <div class="col-md-6 form-group">
            <input type="text" class="form-control con-validate" v-model="suggestion.lastname" :placeholder="$t('sugerencias.campos.apellidos')" minlength=3>
          </div>
          <div class="col-md-6 form-group">
            <input type="email" class="form-control con-validate" v-model="suggestion.email" :placeholder="$t('sugerencias.campos.email') + '*'" required>
          </div>
          <div class="col-md-6 form-group">
            <input type="tel" class="form-control con-validate" v-model="suggestion.phone" :placeholder="$t('sugerencias.campos.telefono')">
          </div>
          <div class="col-md-12 form-group">
            <input type="text" class="form-control con-validate" v-model="suggestion.subject" :placeholder="$t('sugerencias.campos.asunto') + '*'" required>
          </div>
          <div class="col-md-12 form-group">
            <textarea class="form-control con-validate" v-model="suggestion.message" :placeholder="$t('sugerencias.campos.mensaje') + '*'" rows=6
                      required></textarea>
          </div>
          <div class="col-md-12 text-center">
            <!--contact button-->
            <button type="submit" class="mt-30 main-btn">
              {{ $t('sugerencias.enviar_sugerencia') }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import {HttpHelper} from "../../commons/utils/httpHelper";
    import {AppConfig} from "../../appConfig";

    export default {
        name: 'SuggestionsSection',
        data() {
            return {
                suggestion: {
                    name: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    subject:'',
                    message: ''
                }
            }
        },
        computed: {
            locale() {
                return this.$i18n.locale
            },

        },
        async mounted() {
        },
        methods: {
            async submitForm() {

                Swal.fire({
                    title: this.$t('sugerencias.enviado_sugerencia'),
                    showConfirmButton: false,
                    allowOutsideClick: () => false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    }
                });

                try {
                    await this.enviarSugerencia(this.suggestion);

                    Swal.fire({
                        title: this.$t('sugerencias.sugerencia_enviada_titulo'),
                        type: 'success',
                        confirmButtonColor: '#4824bb'
                    });

                    this.resetForm();
                } catch (e) {
                    Swal.fire({
                        title: this.$t('sugerencias.sugerencia_error_titulo'),
                        type: 'error',
                        confirmButtonColor: '#4824bb'
                    });
                }


            },
            async enviarSugerencia(suggestion) {
                return await HttpHelper.post(`${AppConfig.APP_URL}/api/suggestions`, suggestion);
            },
            resetForm(){
                this.suggestion = {
                    name: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    message: ''
                }
            }
        }
    }
</script>

<style>
</style>